import { useCallback } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { lighten, alpha, darken, Button, CircularProgress } from '@material-ui/core';
import { RotateLeft } from '@material-ui/icons';
import { Trans } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { useIsPgm } from '../../stores/EnvironmentStore';
import { useStore, useDispatcher, Actions } from './UseGlobalSearchStore';
import ResultRow from './ResultRow';
import LinkResultRow from './LinkResultRow';
import { useUserGroups } from '../../stores/SessionStore';

export default function Result(props) {
    const { result } = props;
    const { isResult, isHeader, isShowMore } = result;

    if (isHeader) {
        return <HeaderResultRow result={result} />;
    }

    if (isResult) {
        return <LinkResultRow result={result} />;
    }

    if (isShowMore) {
        return <ShowMoreResultRow result={result} />;
    }

    throw new Error('Invalid global search result type');
}

const useHeaderResultRowStyles = makeStyles((theme) => ({
    root: {
        backgroundColor:
            theme.palette.type === 'light'
                ? lighten(alpha(theme.palette.primary.light, 1), 0.88)
                : darken(alpha(theme.palette.primary.light, 1), 0.68),
    },

    title: {
        ...theme.mixins.flex.grow(1),
        ...theme.typography.subtitle2,

        cursor: 'default',
        paddingLeft: theme.spacing(1),
    },
}));

function HeaderResultRow(props) {
    const { result } = props;
    const classes = useHeaderResultRowStyles();

    const { icon: Icon, title, count, total } = result;

    return (
        <ResultRow className={classes.root} rowLayout>
            <Icon fontSize="small" />
            <div className={classes.title}>
                {i18n._(title)} ({count} of {total})
            </div>
        </ResultRow>
    );
}

const useShowMoreResultRowStyles = makeStyles((theme) => ({
    root: {
        padding: `${theme.spacing(0, 4)} !important`,
    },
}));

function ShowMoreResultRow(props) {
    const { result } = props;
    const classes = useShowMoreResultRowStyles();
    const [isPgm] = useIsPgm();
    const [userGroups] = useUserGroups();

    const { isLoading, isNestedLoading, search } = useStore();
    const dispatcher = useDispatcher();

    const startIcon = isLoading ? <CircularProgress size={16} /> : <RotateLeft fontSize="small" />;

    const loadMore = useCallback(() => {
        Actions.loadMore(dispatcher, search, result, isPgm, userGroups);
    }, [dispatcher, search, result, isPgm, userGroups]);

    return (
        <ResultRow className={classes.root}>
            <Button
                disabled={isLoading}
                startIcon={startIcon}
                size="small"
                className={classes.button}
                onClick={loadMore}
            >
                {isLoading && isNestedLoading ? <Trans>Hang on...</Trans> : <Trans>Show More</Trans>}
            </Button>
        </ResultRow>
    );
}
